<div class="card" *ngIf="loading">
  <div class="card-body flex justify-center" style="margin-top: 20px">
    <app-preloader></app-preloader>
  </div>
</div>

<div class="relative min-h-screen" style="margin-top: 20px" *ngIf="!loading">
  <!-- Sticky Header Section -->
  <div class="sticky top-0 z-50 bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/75 shadow-sm">
    <div class="card rounded-none border-b">
      <div class="card-body pb-0">
        <div class="flex justify-between items-center">
          <div class="flex items-center gap-4">
            <div class="relative">
              <img src="{{ userDetails.profileImageUrl }}" alt="" class="img-fluid rounded-full w-100px h-100px"
                style="width: 100px; height: 100px" />
            </div>
            <div>
              <div class="flex items-center gap-7">
                <h4 class="text-2xl">{{ userDetails.name }}</h4>
                <div *ngIf="userDetails.isAdmin"
                  class="badge bg-lightprimary dark:bg-darkprimary border-primary text-primary w-fit">
                  Admin
                </div>
              </div>
              <div class="flex items-center justify-center md:justify-start">
                <span class="bg-success p-1 rounded-full" style="background-color: #4bd08b"></span>
                <h6 class="mb-0 ms-2">Active</h6>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-3">
            <button type="button"
              class="py-2 px-7 inline-flex items-center gap-x-2 text-base font-medium rounded-2xl border border-blue-600 text-blue-600 hover:border-blue-600 hover:text-white hover:bg-blue-600"
              *ngIf="!userDetails.isAdmin" (click)="triggerUpdate(userDetails)">
              Set as admin
            </button>
          </div>
        </div>

        <!-- Navigation Tabs -->
        <nav class="flex justify-start space-x-3 mt-6" aria-label="Tabs" role="tablist">
          <button type="button"
            class="hs-tab-active:border-primary hs-tab-active:text-primary py-2 px-3 inline-flex items-center gap-3 border-b-2 border-transparent text-sm whitespace-nowrap text-bodytext dark:text-darklink hover:text-primary focus:outline-none focus:text-primary disabled:opacity-50 disabled:pointer-events-none dark:text-gray-400 dark:hover:text-primary"
            id="Profile-tab" data-hs-tab="#profile" aria-controls="profile" role="tab"
            routerLink="/portal/user/{{ userId }}/profile" routerLinkActive="active">
            <i class="ti ti-user-circle text-xl"></i><span class="md:flex hidden text-base font-medium">Profile</span>
          </button>
          <button type="button"
            class="hs-tab-active:border-primary hs-tab-active:text-primary py-2 px-3 inline-flex items-center gap-3 border-b-2 border-transparent text-sm whitespace-nowrap text-bodytext dark:text-darklink hover:text-primary focus:outline-none focus:text-primary disabled:opacity-50 disabled:pointer-events-none dark:text-gray-400 dark:hover:text-primary"
            id="Friends-tab" data-hs-tab="#devices" aria-controls="devices" role="tab"
            [class.active]="selectedTab === 'devices'" routerLink="/portal/user/{{ userId }}/devices"
            routerLinkActive="active">
            <i class="ti ti-layout-grid-add text-xl"></i><span
              class="md:flex hidden text-base font-medium">Devices</span>
          </button>
          <button type="button"
            class="hs-tab-active:border-primary hs-tab-active:text-primary py-2 px-3 inline-flex items-center gap-3 border-b-2 border-transparent text-sm whitespace-nowrap text-bodytext dark:text-darklink hover:text-primary focus:outline-none focus:text-primary disabled:opacity-50 disabled:pointer-events-none dark:text-gray-400 dark:hover:text-primary"
            id="Gallery-tab" data-hs-tab="#themes" aria-controls="themes" role="tab"
            [class.active]="selectedTab === 'themes'" routerLink="/portal/user/{{ userId }}/themes"
            routerLinkActive="active">
            <i class="ti ti-id text-xl"></i><span class="md:flex hidden text-base font-medium">Owned Themes</span>
          </button>
          <button type="button"
            class="hs-tab-active:border-primary hs-tab-active:text-primary py-2 px-3 inline-flex items-center gap-3 border-b-2 border-transparent text-sm whitespace-nowrap text-bodytext dark:text-darklink hover:text-primary focus:outline-none focus:text-primary disabled:opacity-50 disabled:pointer-events-none dark:text-gray-400 dark:hover:text-primary"
            id="Followers-tab" data-hs-tab="#subscriptions" aria-controls="subscriptions" role="tab"
            [class.active]="selectedTab === 'subscriptions'" routerLink="/portal/user/{{ userId }}/subscriptions"
            routerLinkActive="active">
            <i class="ti ti-template ext-xl"></i><span class="md:flex hidden text-base font-medium">Subscriptions</span>
          </button>
          <button type="button"
            class="hs-tab-active:border-primary hs-tab-active:text-primary py-2 px-3 inline-flex items-center gap-3 border-b-2 border-transparent text-sm whitespace-nowrap text-bodytext dark:text-darklink hover:text-primary focus:outline-none focus:text-primary disabled:opacity-50 disabled:pointer-events-none dark:text-gray-400 dark:hover:text-primary"
            id="Gallery-tab" data-hs-tab="#history" aria-controls="history" role="tab"
            [class.active]="selectedTab === 'history'" routerLink="/portal/user/{{ userId }}/history"
            routerLinkActive="active">
            <i class="ti ti-list text-xl"></i><span class="md:flex hidden text-base font-medium">History</span>
          </button>

          <!-- Disable / Enable -->
          <button type="button" *ngIf="userDetails.status !== 'Suspended'"
            class="nav-action-item nav-action-item--disable"
            (click)="triggerDisableUser(userDetails)">
            <i class="ti ti-ban nav-action-icon"></i>
            <span class="md:flex hidden">Disable User</span>
          </button>
          <button type="button" *ngIf="userDetails.status === 'Suspended'"
            class="nav-action-item nav-action-item--enable"
            (click)="triggerEnableUser(userDetails)">
            <i class="ti ti-circle-check nav-action-icon"></i>
            <span class="md:flex hidden">Enable User</span>
          </button>

          <!-- Delete -->
          <button type="button"
            class="nav-action-item nav-action-item--delete"
            (click)="triggerDeleteUser(userDetails)">
            <i class="ti ti-trash nav-action-icon"></i>
            <span class="md:flex hidden">Delete User</span>
          </button>
        </nav>
      </div>
    </div>
  </div>

  <!-- Date Range + Download -->
  <!-- <div class="container mx-auto px-4 mt-4">
    <div class="max-w-4xl mx-auto">
      <div class="flex flex-wrap items-end gap-3">
        <div class="flex flex-col">
          <label class="text-sm text-gray-600 mb-1">Start date</label>
          <input
            type="datetime-local"
            class="form-control"
            [(ngModel)]="startDateInput"
          />
        </div>
        <div class="flex flex-col">
          <label class="text-sm text-gray-600 mb-1">End date</label>
          <input
            type="datetime-local"
            class="form-control"
            [(ngModel)]="endDateInput"
          />
        </div>
        <button
          type="button"
          class="py-2 px-7 inline-flex items-center gap-x-2 text-base font-medium rounded-2xl border border-blue-600 text-blue-600 hover:border-blue-600 hover:text-white hover:bg-blue-600"
          (click)="onDownloadLocations()"
        >
          Download Locations
        </button>
      </div>
    </div>
  </div> -->

  <!-- Router Outlet Content -->
  <div class="container mx-auto px-4 py-6 mt-4">
    <div class="max-w-4xl mx-auto">
      <!-- Centered container -->
      <router-outlet></router-outlet>
    </div>
  </div>

</div>